module.exports = __webpack_public_path__ + "img/arrow_right.a307d8d1.svg";